export const pollingConfig = {
    idleThresholdMs: 60 * 60 * 1000 // 1 hour of inactivity - polling paused
};

export const debounceIntervals = {
    panel: {
        onlineUserFlagInterval: 20000 // 20s
    },
    quorum: {
        interval: 1000
    },
    voting: {
        interval: 1000
    },
    sessionContentChanged: {
        interval: 2500
    }
};